import { render } from "./ThankYou.vue?vue&type=template&id=86115aae"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__